import { cn } from 'noddi-ui-common';
import { NoddiButton } from 'noddi-ui-web';
import { UNAVAILABLE_TEXT } from './utils';

type Props = {
  onNextButtonClick: () => void;
  onPrevButtonClick: () => void;
  translations: { nextButton: string; prevButton: string };
  /** The visible days' date range, between the two buttons. */
  label: string;
  isAtStart: boolean;
  isAtEnd: boolean;
};

// At either end the button only looks spent: it stays pressable so it can open the dialog that says
// why there are no earlier/later days (e.g. stored tires need preparing first).
export const SliderArrows = ({
  onNextButtonClick,
  onPrevButtonClick,
  translations,
  label,
  isAtStart,
  isAtEnd
}: Props) => (
  <div className='flex items-center justify-between gap-3'>
    <NoddiButton
      variant='outline'
      size='small'
      onClick={onPrevButtonClick}
      startIcon='ChevronLeft'
      className={cn('h-9 md:h-8', isAtStart && UNAVAILABLE_TEXT)}
    >
      <span className={narrowScreenLabel}>{translations.prevButton}</span>
    </NoddiButton>
    {/* Wraps rather than truncates: a range across two months can outgrow the gap on a narrow phone. */}
    <span aria-live='polite' className='min-w-0 text-center text-base leading-tight font-semibold text-balance'>
      {label}
    </span>
    <NoddiButton
      variant='outline'
      size='small'
      onClick={onNextButtonClick}
      endIcon='ChevronRight'
      className={cn('h-9 md:h-8', isAtEnd && UNAVAILABLE_TEXT)}
    >
      <span className={narrowScreenLabel}>{translations.nextButton}</span>
    </NoddiButton>
  </div>
);

// Below 360px both labels and a month name no longer fit on one row, so the buttons fall back to their
// chevrons; the label stays for screen readers.
const narrowScreenLabel = 'max-[359px]:sr-only';
